import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
	EndorsementProps,
} from '@app/props';
// Import hooks.
import {
	useAppRedirect,
} from '@app/hooks/utility';

interface UseEndorsementPropsFromRouterResult extends EndorsementProps {

}

const useEndorsementPropsFromRouter = (): UseEndorsementPropsFromRouterResult => {
	const { redirect } = useAppRedirect();
	const params = useParams();

	// Parse out the router parameters for endorsement id.
	const endorsementId: number | undefined = React.useMemo(() => {
		return isNaN(params['endorsementId'])
			? undefined
			: parseInt(params['endorsementId'], 10);
	}, [params]);

	React.useEffect(() => {
		if (endorsementId === undefined) {
			redirect();
		}
	}, [endorsementId]);

	return {
		endorsementId: endorsementId ?? -1,
	}
}

// Export results.
export {
	UseEndorsementPropsFromRouterResult,
}

export default useEndorsementPropsFromRouter;